import type { BaseContainer } from '#build/components';
<template>
  <BaseContainer>
    <div class="flex justify-center">
      <h1 class="mt-24 text-secondary text-6xl">Pagina niet gevonden</h1>
    </div>
  </BaseContainer>
</template>
